import React from "react";
import { noop } from "@common/helpers/function";
import {
    CASH_ITEM_TRANSACTION_TYPE_LABELS,
    CASH_ITEM_TRANSACTION_TYPES,
    TransactionType,
} from "@common/types/transaction";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const options: Array<FilterMultiselectOption<TransactionType>> =
    CASH_ITEM_TRANSACTION_TYPES.map((type) => ({
        value: type,
        label: CASH_ITEM_TRANSACTION_TYPE_LABELS[type],
        searchableLabel: CASH_ITEM_TRANSACTION_TYPE_LABELS[type].toLowerCase(),
    }));

export const CashItemTypeFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <div className={styles.filter}>
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={filters.transactionTypes ?? []}
            onChange={(transactionTypes) =>
                onChange({
                    transactionTypes:
                        transactionTypes.length > 0
                            ? transactionTypes
                            : undefined,
                })
            }
            name="transactionTypes"
            onBlur={noop}
        />
    </div>
);
